/**
 * Slider Component
 *
 */
class sliderElement extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper-slider');
  }


  connectedCallback() {

    if(!this.sliderEle) return;

    let sliderOptions = this.sliderEle.getAttribute('data-slider');
    sliderOptions = JSON.parse(sliderOptions);

    // Set up nav slider
    var thumbSlider = document.querySelector('.' + this.sliderEle.getAttribute('data-nav'));
    if(this.sliderEle.hasAttribute('data-nav')){
      if(!thumbSlider){
        return;
      }
      let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
      thumbSliderOptions = JSON.parse(thumbSliderOptions);
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

      sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    sliderOptions.on = {
      init: (event) => {
        const currentTarget = event.el;

        currentTarget.classList.toggle('slider-active', event.virtualSize > event.size);
      },
    };

    let slider = new Swiper(this.sliderEle, sliderOptions);
    slider.on('resize', function (event) {
      const currentTarget = event.el;

      currentTarget.classList.toggle('slider-active', event.virtualSize > event.size);
    });

    this.slideChangeEvt(slider);
  }

  slideChangeEvt(slider){
    slider.on('slideChange', (event) => {
      const currentTarget = event.el;

      let activeVideos = currentTarget.querySelectorAll('.custom-video-container.playing--video');
      if(activeVideos.length > 0){
        activeVideos.forEach((container)=>{
          let video = container.querySelector('custom-video');
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
          }else if(videoType == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }
    });
    slider.on('slideChangeTransitionStart', (event) => {
      const currentTarget = event.el;
      if (currentTarget.closest('[data-joola-slider]')) {
        let activeSlide=currentTarget.querySelector('.swiper-slide-active');
        currentTarget.querySelector('.active')?.classList.remove('active')
        activeSlide.classList.add('active');
      }
    });
  }
}
customElements.define('slider-element', sliderElement);
